import { toastr } from 'react-redux-toastr';
import {
  addImage,
  addQrCode,
  addText,
  createPdfDocument,
  setFont,
} from '../pdf';
import LogoCiva from '../../resources/images/logo-civa.png';
import { PAYMENT_METHOD_PAGO_EN_DESTINO } from '../../config/constants';
import { BASE_PRINT_AGENT_URL } from '../../config/endpoints';

const margin = 3;
const qrWidth = 38;
const qrHeight = 38;
const imageWidth = 25;
const imageHeight = 8;
let myY = -margin;

const getDeliveryCode = (deliveryAddress, transactionCode) => {
  if (deliveryAddress) {
    return 'DOM';
  }
  if (transactionCode === PAYMENT_METHOD_PAGO_EN_DESTINO) {
    return 'AGE - PD';
  }
  return 'AGE';
};

const printItemTicket = async (
  doc,
  {
    shipmentFields: { origin, destiny, originAgencyCode, destinyAgencyCode },
    consignedFields: {
      consignedName,
      consignedDocumentType,
      consignedDocumentNumber,
    },
    descriptionItem,
    correlationCodeItem,
    itemNumber,
    itemList,
    weight,
    isFirstPrint,
    deliveryAddress,
    transactionCode,
  },
) => {
  myY = -margin;

  if (!isFirstPrint) {
    doc.addPage('l', 'mm');
  }

  const column1X = 3;
  const column2X = 70;

  setFont(doc, 'bold');
  doc.setFontSize(10);

  console.log('deliveryAddress', deliveryAddress);
  console.log('paymentMethodName', transactionCode);

  const deliveryCode = getDeliveryCode(deliveryAddress, transactionCode);

  setFont(doc, 'bold');

  addImage(doc, LogoCiva, column1X, myY + margin * 2, imageWidth, imageHeight);

  doc.setFontSize(16);

  addText(doc, deliveryCode, column1X + 44, myY + margin * 4, 100, 'center');

  doc.setFontSize(14);

  addText(
    doc,
    correlationCodeItem,
    column2X - 7,
    (myY += margin * 4),
    75,
    'left',
  );

  setFont(doc);
  doc.setFontSize(8);
  addText(
    doc,
    'Turismo Civa S.A.C - RUC:20102427891',
    column1X,
    (myY += margin * 2),
    75,
    'left',
  );

  setFont(doc, 'bold');
  doc.setFontSize(8);

  doc.text('DESDE:', column1X, (myY += margin * 1.5));

  doc.setFontSize(10);
  const originText = `${origin} (${originAgencyCode || '-'})`.toUpperCase();
  const originWrappedText = doc.splitTextToSize(originText, 70);
  doc.text(originWrappedText, column1X, (myY += margin * 1.2), {
    align: 'left',
  });

  myY += margin * originWrappedText.length;

  doc.setFontSize(8);
  doc.text('HASTA:', column1X, (myY += margin * 1.2));

  doc.setFontSize(10);
  const destinyText = `${destiny} (${destinyAgencyCode || '-'})`.toUpperCase();
  const destinyWrappedText = doc.splitTextToSize(destinyText, 77);
  doc.text(destinyWrappedText, column1X, (myY += margin * 1.2), {
    align: 'left',
  });

  myY += margin * destinyWrappedText.length;

  setFont(doc, 'bold');
  doc.setFontSize(8);
  addText(
    doc,
    'DATOS DEL CONSIGNADO',
    column1X,
    (myY += margin * 1.2),
    75,
    'left',
  );

  doc.setFontSize(8);
  setFont(doc);

  addText(
    doc,
    `Nombre: ${consignedName}`,
    column1X,
    (myY += margin),
    80,
    'left',
  );

  addText(doc, 'Tipo de Documento', column1X, (myY += margin), 40, 'left');
  addText(doc, `: ${consignedDocumentType}`, column1X + 37, myY, 55, 'left');

  addText(doc, 'Numero de Documento', column1X, (myY += margin), 40, 'left');
  addText(doc, `: ${consignedDocumentNumber}`, column1X + 37, myY, 55, 'left');

  setFont(doc, 'bold');
  doc.setFontSize(14);

  const MAX_LENGTH = 20;

  if (descriptionItem.length > MAX_LENGTH) {
    addText(
      doc,
      descriptionItem.substring(0, MAX_LENGTH),
      column1X,
      (myY += margin * 2),
      55,
      'left',
    );
  } else {
    addText(doc, descriptionItem, column1X, (myY += margin * 2), 55, 'left');
  }

  setFont(doc);
  doc.setFontSize(10);

  myY = -margin;
  setFont(doc, 'bold');
  doc.setFontSize(16);

  myY += margin * 4.1;

  await addQrCode(doc, correlationCodeItem, column2X, myY, qrWidth, qrHeight);

  setFont(doc);
  doc.setFontSize(10);
  addText(
    doc,
    `PAQUETE: ${itemNumber}/${itemList}`,
    column2X + 2,
    (myY += qrHeight + margin),
    75,
    'left',
  );
  addText(doc, `PESO: ${weight} kg`, column2X + 2, myY + 6, 55, 'left');
};

const formatTicket = (ticket) => {
  const formatedTicket = {
    shipmentFields: {
      origin: ticket.sourceLocationName,
      originAgencyCode: ticket.sourceAgencyCode,
    },
    consignedFields: {
      consignedName: ticket.consigneeCustomer.fullName,
      consignedDocumentType: ticket.consigneeCustomer.identificationType.name,
      consignedDocumentNumber: ticket.consigneeCustomer.idDocumentNumber,
    },
    destinationAddress: ticket.destinationAddress
      ? ticket.destinationAddress
      : '-',
    cargoItemList: ticket.cargoItemList
      ? ticket.cargoItemList
      : ticket.internalCargoItemList,
    comments: ticket.comments,
    transactionCode: ticket.transactionCode,
    deliveryAddress: ticket.deliveryAddress,
  };

  return formatedTicket;
};

function arrayBufferToBase64(buffer) {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
}

export default async function printTicketCargo(ticket) {
  const doc = createPdfDocument('l', 'mm', [112, 65]);

  const formatedTicket = formatTicket(ticket);

  const {
    shipmentFields: { origin, originAgencyCode },
    consignedFields: {
      consignedName,
      consignedDocumentType,
      consignedDocumentNumber,
    },
    comments,
    cargoItemList,
    destinationAddress,
    transactionCode,
    deliveryAddress,
  } = formatedTicket;

  const printTasks = cargoItemList.map((item, index) => async () => {
    await printItemTicket(doc, {
      shipmentFields: {
        origin,
        originAgencyCode,
        destiny: item.finalDestinationLocation
          ? item.finalDestinationLocation.name
          : destinationAddress,
        destinyAgencyCode: item.finalDestinationLocation
          ? item.finalDestinationLocation.agencyCode
          : '',
      },
      consignedFields: {
        consignedName,
        consignedDocumentType,
        consignedDocumentNumber,
      },
      descriptionItem: item.description,
      comments,
      correlationCodeItem: item.correlation,
      itemNumber: index + 1,
      itemList: cargoItemList.length,
      weight: item.weight,
      isFirstPrint: index === 0,
      deliveryAddress,
      transactionCode,
    });
  });

  await printTasks.reduce(
    (promiseChain, currentTask) => promiseChain.then(() => currentTask()),
    Promise.resolve(),
  );

  doc.autoPrint();
  const arrayBuffer = doc.output('arraybuffer');

  const blob = new Blob([arrayBuffer], { type: 'application/pdf' });
  const blobUrl = URL.createObjectURL(blob);
  const pdfBase64 = arrayBufferToBase64(arrayBuffer);

  try {
    await fetch(`${BASE_PRINT_AGENT_URL}/health`);
  } catch {
    window.open(blobUrl, '_blank');
    toastr.error(
      'Error',
      'El agente de impresión no está corriendo. Abre print-agent.exe primero.',
    );
    return;
  }

  try {
    const response = await fetch(`${BASE_PRINT_AGENT_URL}/print`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ pdfBase64, printingType: 'sticker' }),
    });

    if (!response.ok) {
      const errData = await response.json();
      throw new Error(errData.error || 'Error al imprimir');
    }
  } catch (err) {
    window.open(blobUrl, '_blank');
    toastr.error('Error', err.message);
  }
}
